import { type FC } from "react";
import { cassetteHeading } from "../../styles.css";

export type HeaderProps = {
  shopOrBrandName: string;
  businessTypeAndOccupation: string;
};

export const Header: FC<HeaderProps> = ({ shopOrBrandName, businessTypeAndOccupation }) => (
  <h2 className={cassetteHeading}>
    {shopOrBrandName}│<span>{businessTypeAndOccupation}</span>
  </h2>
);
